module.exports = __webpack_public_path__ + "assets/4a433a51214af90526b8dff4d58ca425.png";